import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { RouterModule } from '@angular/router';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxListBoxModule } from 'jqwidgets-ng/jqxlistbox';
import { ConfirmDialogModule } from '../utils/confirm-dialog/confirm-dialog.module';
import { jqxRibbonModule } from 'jqwidgets-ng/jqxribbon';
import { jqxPopoverModule } from 'jqwidgets-ng/jqxpopover';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    RouterModule,
    jqxButtonModule,
    jqxGridModule,
    jqxLoaderModule,
    jqxInputModule,
    jqxDropDownListModule,
    jqxListBoxModule,
    ConfirmDialogModule,
    jqxRibbonModule,
    jqxPopoverModule
  ]
})
export class MainModule { }
